module.exports = __webpack_public_path__ + "static/media/turning-red.46c6c7b9.png";